'use strict';

var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');

var _interopRequireWildcard = require('@babel/runtime/helpers/interopRequireWildcard');

Object.defineProperty(exports, '__esModule', {
    value: true,
});
exports.filterItems = exports.parsePrice = exports.parseAvailability = void 0;

var _react = _interopRequireWildcard(require('react'));

var _lodash = _interopRequireDefault(require('lodash'));

var _raivenUtils = require('../../../../raiven-utils');

var parseAvailability = function parseAvailability(str, isAvailable) {
    if (isAvailable) {
        return /*#__PURE__*/ _react['default'].createElement(
            _react.Fragment,
            null,
            /*#__PURE__*/ _react['default'].createElement(
                'span',
                {
                    className: 'availability available',
                },
                'Available',
            ),
            /*#__PURE__*/ _react['default'].createElement(
                'span',
                {
                    className: 'details',
                },
                str,
            ),
        );
    } else {
        return /*#__PURE__*/ _react['default'].createElement(
            _react.Fragment,
            null,
            /*#__PURE__*/ _react['default'].createElement('span', {
                className: 'availability backordered',
            }),
            /*#__PURE__*/ _react['default'].createElement(
                'span',
                {
                    className: 'details',
                },
                str,
            ),
        );
    }
};

exports.parseAvailability = parseAvailability;

var parsePrice = function parsePrice(price) {
    var newPrice = price.match(/(\d+|\.)/g); //numbers only

    if (_lodash['default'].isArray(newPrice) && !_lodash['default'].isEmpty(newPrice)) {
        newPrice = newPrice.join('');
    }

    var formattedPrice = (0, _raivenUtils.FormatNumber)(newPrice, {
        parts: true,
    });
    return /*#__PURE__*/ _react['default'].createElement(
        _react.Fragment,
        null,
        /*#__PURE__*/ _react['default'].createElement(
            'div',
            {
                className: 'money-symbol',
            },
            '$',
        ),
        /*#__PURE__*/ _react['default'].createElement(
            'div',
            {
                className: 'dollars',
            },
            formattedPrice.whole,
        ),
        /*#__PURE__*/ _react['default'].createElement(
            'div',
            {
                className: 'cents',
            },
            formattedPrice.fraction,
        ),
    );
};

exports.parsePrice = parsePrice;

var filterItems = function filterItems(items, _ref) {
    var isAvailable = _ref.isAvailable,
        searchTerm = _ref.searchTerm;
    var filteredItems = [];

    if (_lodash['default'].isArray(items.PartList) && !_lodash['default'].isEmpty(items.PartList)) {
        filteredItems = items.PartList;
    } else {
        if (_lodash['default'].isArray(items) && !_lodash['default'].isEmpty(items)) {
            filteredItems = items;
        }
    }

    if (isAvailable) {
        filteredItems = filteredItems.filter(function(item) {
            return item.IsAvailable;
        });
    }

    if (searchTerm) {
        filteredItems = filteredItems.filter(function(item) {
            return item.Name.toLowerCase().includes(searchTerm.toLowerCase());
        });
    }

    return filteredItems;
};

exports.filterItems = filterItems;
